var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeShadow = function SvgEyeShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 42,
    height: 34,
    viewBox: "0 0 0.83 0.67",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.06.43c.11.22.58.35.71.04C1.03-.14-.22-.1.06.43zM.74.2C.77.21.68.27.64.29.41.42.3.34.12.19.31.03.49.03.74.2z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.04,
    strokeMiterlimit: 22.9256
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.74.2C.77.21.68.27.64.29.41.42.3.34.12.19.31.03.49.03.74.2z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256
  })));
};

export default SvgEyeShadow;